<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid>
        <v-row
            class="flex-child"
        >
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-container fluid>
                        <v-row align="center">
                            <v-col cols="12" md="2" sm="6" xs="3">
<!--                                <v-text-field-->
<!--                                    solo-->
<!--                                    hide-details-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.student.name')"-->
<!--                                    v-model="searchData.name"-->
<!--                                />-->
                                <el-input v-model="searchData.name" placeholder="请输入姓名"></el-input>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
<!--                                <v-select-->
<!--                                    :items="classItems"-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.student.class')"-->
<!--                                    hide-details-->
<!--                                    solo-->
<!--                                    v-model="searchData.classId"-->
<!--                                ></v-select>-->
                                <el-select v-model="searchData.classId" @change="pageChange" filterable
                                           placeholder="选择班级">
                                    <el-option
                                        v-for="item in classItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
                                <el-select v-model="searchData.firstClassId" @change="pageChange" filterable
                                           placeholder="选择注册班级">
                                    <el-option
                                        v-for="item in classRegItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="3">
<!--                                <v-select-->
<!--                                    :items="schoolItems"-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.student.school')"-->
<!--                                    hide-details-->
<!--                                    solo-->
<!--                                    v-model="searchData.schoolId"-->
<!--                                ></v-select>-->
                                <el-select v-model="searchData.schoolId" @change="pageChange" filterable
                                           placeholder="选择学校">
                                    <el-option
                                        v-for="item in schoolItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-col>

                            <v-col cols="12" md="4" sm="3" xs="3">
                                <v-row justify="end">
                                    <v-col cols="12" md="4">
                                        <v-btn color="primary" v-5="permissionCode.search" @click="pageChange" dark large>
                                            <v-icon left>mdi-magnify</v-icon>
                                            {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-btn color="primary" v-5="permissionCode.seat" @click="seatSearch.showDetail=true" dark large>
                                            <v-icon left>mdi-target-account</v-icon>
                                            {{ $vuetify.lang.t('$vuetify.custom.student.seatSearch') }}
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-btn color="primary" v-5="permissionCode.add" @click="studentAdd=true" dark large>
                                            <v-icon left>mdi-target-account</v-icon>
                                            {{ $vuetify.lang.t('$vuetify.custom.student.add') }}
                                        </v-btn>
                                    </v-col>
                                   
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-col>
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="id"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                        <template v-slot:item.actions="{ item }">
                            <v-btn color="normal" v-5="permissionCode.detail" x-small @click="showDetailDialog(item)" class="ml-2">
                                <v-icon small>
                                    mdi-account-details
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.detail') }}
                            </v-btn>
                            <!--                            <v-btn color="normal" x-small @click="showDetailDialog(item)" class="ml-2">-->
                            <!--                                <v-icon small>-->
                            <!--                                    mdi-refresh-->
                            <!--                                </v-icon>-->
                            <!--                                {{ $vuetify.lang.t('$vuetify.custom.student.changeClass') }}-->
                            <!--                            </v-btn>-->
                            <v-btn color="normal" v-5="permissionCode.come" x-small @click="showComeDialog(item)" class="ml-2">
                                <v-icon small>
                                    mdi-human-male
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.student.comeWithStudent') }}
                            </v-btn>
                            <v-btn color="normal" v-5="permissionCode.update" x-small @click="updateItem(item)" class="ml-2">
                                <v-icon small>
                                    mdi-update
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.student.update') }}
                            </v-btn>
                            <v-btn class="ml-2" v-5="permissionCode.follow" :color="isEnable(item).color"
                                   x-small @click="follow(item)">
                                <v-icon small>
                                    {{isEnable(item).icon}}
                                </v-icon>
                                {{isEnable(item).text}}
                            </v-btn>
                            <v-btn class="ml-2" v-5="permissionCode.hide" color="error"
                                   x-small @click="clickHide(item)">
                                <v-icon small>mdi-delete-empty</v-icon>
                                隐藏
                            </v-btn>
                            <v-btn color="normal" v-if="!item.atWb" v-5="permissionCode.set" x-small @click="setOuter(item)" class="ml-2">
                                <v-icon small>
                                    mdi-update
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.student.setOuter') }}
                            </v-btn>
                            <v-btn color="normal" v-5="permissionCode.set" x-small @click="setPic(item)" class="ml-2">
                                上传学生图片
                            </v-btn>
                            <v-btn color="normal" v-5="permissionCode.set" x-small @click="getPic(item)" class="ml-2">
                              查看照片
                            </v-btn>
                             <v-btn color="normal" v-5="permissionCode.set" x-small  class="ml-2">
                               {{ item.pic ?'已上传照片':'暂无照片'}}
                            </v-btn>
                            <!--这里改为自动钉钉转班暂时去掉
                            <v-btn color="normal" x-small @click="clickChangeClass(item)" class="ml-2">
                                <v-icon small>
                                    mdi-car-turbocharger
                                </v-icon>
                                {{ $vuetify.lang.t('$vuetify.custom.student.changeClasses') }}
                            </v-btn>-->
                        </template>
                    </v-data-table>
                </v-sheet>
            </v-col>
            <!--这里改为自动钉钉转班暂时去掉
            <v-dialog v-model="changeClasses.showDetail" max-width="500px">
                <v-card>
                    <v-card-title class="d-flex flex-row-reverse">
                        <v-btn x-small fab @click="changeClasses.showDetail=false">
                            <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="9">
                                    <v-select
                                        v-model="changeClasses.classId"
                                        :items="changeClasses.items"
                                        label="选择班级"
                                        hide-details
                                        item-text="className"
                                        item-value="id"
                                        solo
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="3" style="text-align: center;">
                                    <v-btn color="error" @click="toClass" large>转班</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>-->
            <v-dialog v-model="hideData.showDetail" max-width="500px">
                <v-card>
                    <v-card-title class="d-flex flex-row-reverse">
                        <v-btn x-small fab @click="hideData.showDetail=false">
                            <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-textarea
                                        v-model="hideData.hideRemark"
                                        solo
                                        counter
                                        :rules="hideData.rules"
                                        label="隐藏事由"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" style="text-align: center;">
                                    <v-btn color="error" @click="toHide" large>确认隐藏</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="seatSearch.showDetail" max-width="500px">
                <v-card>
                    <v-card-title class="d-flex flex-row-reverse">
                        <v-btn x-small fab @click="seatSearch.showDetail=false">
                            <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="9">
                                    <v-select
                                        v-model="seatSearch.classId"
                                        :items="seatSearch.items"
                                        label="选择班级"
                                        hide-details
                                        item-text="className"
                                        item-value="id"
                                        solo
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="3" style="text-align: center;">
                                    <v-btn color="primary" @click="searchSeat" large>查看</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="showDetail" max-width="1000px">
                <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
            </v-dialog>
            <v-dialog v-model="dialog" persistent max-width="700px">
                <student-update v-model="dialog" :studentMsg="studentMsg" @initialize="pageChange"></student-update>
            </v-dialog>
            <v-dialog v-model="studentAdd" persistent max-width="700px">
                <student-add v-model="studentAdd" @initialize="pageChange"></student-add>
            </v-dialog>
            <v-dialog v-model="comeDialog" max-width="700px">
                <come-student v-model="comeDialog" :studentId="studentId"></come-student>
            </v-dialog>
            <v-dialog v-model="timeDialog" persistent max-width="700px">
                <set-outer v-model="timeDialog" :studentId="studentId" @initialize="pageChange"></set-outer>
            </v-dialog>
            <!-- <v-dialog v-model="picdilog" persistent max-width="700px">
             <v-card>
                    <v-file-input accept="image/*" v-model="file" @change="fileChange" :label="$vuetify.lang.t('$vuetify.custom.user.uploadAvatar')"></v-file-input>
             </v-card>

            </v-dialog> -->
            <v-dialog v-model="getpicdilog" max-width="800px">
            <img ref="imgRef" v-show="true" :src="filePath" :preview="fileDesc" :preview-text="fileDesc">
        </v-dialog>
            <v-dialog
                v-model="picdilog"
                max-width="500px"
                persistent
            >
                <v-card>
                    <v-card-title>
                    学生照片
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <!-- <v-col cols="12">
                                <v-textarea
                                    outlined
                                    hide-details
                                    :label="$vuetify.lang.t('$vuetify.custom.score.appraise')"
                                    v-model="appraise"
                                />
                            </v-col> -->
                            <v-col cols="12">
                                <v-file-input accept="image/*" v-model="appraiseFile" label="请选择图像文件"></v-file-input>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="error" dark
                            @click="recordCancel"
                        >
                            取消
                        </v-btn>
                        <v-btn
                            color="success" dark @click="appraiseBtn"
                        >
                            提交
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>
<style></style>
<script>
    import scoreDetail from '../score/score-detail'
    import studentUpdate from './student-update'
    import studentAdd from './student-add'
    import comeStudent from './come-student'
    import setOuter from './set-outer'

    export default {
        data() {
            return {
                formData: {},
                picdilog:false,
                getpicdilog:false,
                picImg:'',
                filePath:'',
                addform:{
                img:''
            },
            appraiseFile: '',
                permissionCode:{
                    detail:'biz:student:detail',
                    come:'biz:student:come',
                    update:'biz:student:update',
                    follow:'biz:student:follow',
                    hide:'biz:student:hide',
                    search:'biz:student:search',
                    seat:'biz:student:seat',
                    set:'biz:student:set',
                    add:'biz:student:add',
                },
                timeDialog:false,
                studentId: '',
                stuDetailMsg: {},
                classItems: [
                    {text: '选择班级', value: ''},
                ],
                classRegItems: [
                    {text: '选择注册班级', value: ''},
                ],
                comeDialog: false,
                showDetail: false,
                dialog: false,
                studentAdd: false,
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                searchData: {
                    name: '',
                    classId: '',
                    schoolId: '',
                    firstClassId:''
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.name'), value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.gender'),
                        value: 'genderDesc',
                        sortable: false,
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.age'), value: 'age',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.class'), value: 'className',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.firstClassName'), value: 'firstClassName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.school'), value: 'schoolName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.source'),
                        value: 'sourceTypeDesc',
                        sortable: false,
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.changeClassNum'), value: 'transferTimes',
                    },
                    // {
                    //     text: this.$vuetify.lang.t('$vuetify.custom.student.icePerson'), value: 'emergencyPerson',
                    // },
                    // {
                    //     text: this.$vuetify.lang.t('$vuetify.custom.student.iceCall'), value: 'emergencyCall',
                    // },
                    {text: this.$vuetify.lang.t('$vuetify.custom.actions'), value: 'actions', sortable: false},
                ],
                totalDesserts: 0,
                desserts: [],
                studentMsg: {},
                schoolItems: [
                    {text: '选择学校', value: ''},
                ],
                /*changeClasses: {
                    showDetail: false,
                    items: [],
                    classId: "",
                    oldClassId: "",
                    stuId: "",
                },*/
                seatSearch: {
                    showDetail: false,
                    items: [],
                    classId: "",
                },
                hideData:{
                    stuId:'',
                    showDetail:false,
                    hideRemark:'',
                    rules:[v => v.length <= 100 || '最多输入100字'],
                },
            }

        },
        mounted() {
            /*this.$api.classList.getAllClass().then(data => {
                for (let i = 0; i < 5; i++) {
                    this.changeClasses.items.push(data.data[i]);
                }
            });
            this.initSelect()*/
            this.$api.classList.getAllClass({
                params: {
                    type:'0'
                }
            }).then(data => {
                for (let i = 0; i < 5; i++) {
                    this.seatSearch.items.push(data.data[i]);
                }
            });
            this.initSelect()
        },
        methods: {
               

            getImg(item){
                this.filePath = this.$file.fileDownload(this.fileId)
                // return 'http://localhost:8080/files/40e4f30c652243d094e822ee798165df.jpg';
            },
            async appraiseBtn() {
                console.log("this.appraiseFile",this.appraiseFile);
                if (this.appraiseFile != "" && this.appraiseFile != null) {
                let form = new FormData();
                form.append("filePath", "recordFiles");
                form.append('file', this.appraiseFile);
                let files = await this.$file.fileUpload(form)
                console.log("this.appraiseFile",files);
                this.formData.pic=files.fileId;
                this.formData.specAttention=null;
                this.$api.student.updateStudent(this.formData).then(data => {
                      if (data.flag) {
                        // this.$dialog.alert("修改成功");
                        // this.$emit('initialize')
                        this.picdilog = false
                      }else{
                        // this.$dialog.alert(data.msg)
                      }
                    })
                console.log("this.appraiseFile",this.formData);

            }
            },
            recordCancel() {
            this.picdilog = false;
            this.getpicdilog=false;
            // this.record = ''
            // this.formData.stuId = ''
            // this.formData.examId = ''
            // this.formData.comment = ''
            // this.recordFile = ""
            // this.formData.recordType = 1
            // this.formData.fileIds = []
        },
            hanadle_success(res, file, fileList) {
                this.addform.img = res.path; //实现单独上传
                //下面这个实现多种上传，两个都写上也没事，用不到也不报错
                const result = fileList.every((item) => item.status === "success");
                if (result) {
                    fileList.map((item) => {
                        item.response &&
                            this.fileList.push({
                                name: "",
                                url: item.response.path,
                            });
                        return true;
                    });
                }
		},
        getPic(item){
            console.log("item",item);
            if(item.pic!=null){
                this.filePath = this.$file.fileDownload(item.pic)
                this.getpicdilog=true;

            }else{
                this.$dialog.alert("请选择班级");
            }
            // this.picImg='https://tea.etoak.com/api/'+item.pic;
        },
        setPic(item){
            console.log("item",item);
            this.formData=item;
            this.studentId = item.id
            this.picdilog = true  
        },
            setOuter(item){
                this.studentId = item.id
                this.timeDialog = true
            },
            follow(item) {
                this.$api.student.updateStudent({
                    id: item.id,
                    specAttention: !item.specAttention
                }).then(data => {
                    if (data.flag) {
                        this.initialize()
                    }
                })
            },

            isEnable(item) {
                let icon = 'mdi-check-circle';
                let color = 'success';
                let text = this.$vuetify.lang.t('$vuetify.custom.student.follow')
                if (item.specAttention) {
                    icon = 'mdi-close-circle';
                    color = 'error';
                    text = this.$vuetify.lang.t('$vuetify.custom.student.cancelFollow')
                }
                return {
                    icon: icon,
                    color: color,
                    text: text
                }
            },

            initSelect() {
                this.initClassItems()
                this.initSchoolItems()
            },

            initSchoolItems() {
                this.$api.school.getSchoolSelect().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.schoolItems.push({text: obj.schoolName, value: obj.id})
                        })
                    }
                })
            },

            initClassItems() {
                this.$api.classList.getAllClass().then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.classItems.push({text: obj.className, value: obj.id})
                            if(obj.className != "长假人群"){
                                this.classRegItems.push({text: obj.className, value: obj.id})
                            }
                        })
                    }
                })
            },
            updateItem(item) {
                this.dialog = true
                this.studentMsg = item
            },
            //用户详细弹窗
            showDetailDialog(item) {
                this.showDetail = true;
                this.stuDetailMsg = item
                this.stuDetailMsg.studentId = this.stuDetailMsg.id
            },
            showComeDialog(item) {
                this.comeDialog = true;
                this.studentId = item.id
            },
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            initialize() {
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.student.getStudentList(
                    Object.assign({}, this.searchData, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })
                // this.loading = false;
                // let data = Mock.mock({
                //     'data|10': [
                //         {
                //             'name': '@cname',
                //             "gender|+1": ['男', '女'],
                //             "age|18-40": 40,
                //             "class": 'et2001',
                //             "school": 'xxx学校',
                //             "source": 'xxx',
                //             "changeClassNum|1-10": 10,
                //         }
                //     ]
                // });
                // this.desserts = data.data
                // this.totalDesserts = 10;

            },
            changeOptions(option) {
                this.initialize()
            },
            searchSeat(){
                if(!this.seatSearch.classId){
                    this.$dialog.alert("请选择班级");
                    return;
                }
                this.$router.push({
                    name: "SeatsSearch",
                    params: {
                        classId:this.seatSearch.classId
                    }
                })
            },
            clickHide(item){
                this.hideData.showDetail = true;
                this.hideData.stuId = item.id;
            },
            toHide(){
                if(!this.hideData.hideRemark){
                    this.$dialog.alert("请填写隐藏事由");
                    return;
                }
                this.$dialog.confirm("确定要隐藏当前学生吗?当前操作不可逆!",'提示',()=>{
                    this.$api.student.hideStudent({
                        stuId:this.hideData.stuId,
                        hideRemark: this.hideData.hideRemark
                    }).then(data=>{
                        if(data.flag){
                            this.hideData.showDetail = false;
                            this.initialize()
                        }
                    })
                });
            },
            /*这里改为自动钉钉转班暂时去掉
            clickChangeClass(item){
                this.changeClasses.showDetail=true;
                this.changeClasses.stuId=item.id;
                this.changeClasses.oldClassId=item.classId;
            },
            toClass(){
                if(!this.changeClasses.stuId || !this.changeClasses.classId){
                    this.$dialog.alert("请选择班级");
                    return;
                }
                if(this.changeClasses.classId == this.changeClasses.oldClassId){
                    this.$dialog.alert("不能转到原有班级");
                    return;
                }
                this.$api.student.changeClasses({
                    stuId:this.changeClasses.stuId,
                    classId:this.changeClasses.classId
                }).then(data=>{
                    if(data.flag){
                        this.$dialog.alert("转班成功请重新排座");
                        this.$router.push({
                            name: "RowOfSeats",
                            params: {
                                classId:this.changeClasses.classId
                            }
                        })
                    }
                })
            }*/
        },
        components: {
            scoreDetail,
            studentUpdate,
            comeStudent,
            setOuter,
            studentAdd,
        },
    }
</script>
<style scoped>
.avatar-uploader .el-upload {
	border: 10px dashed gold;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	border: 1px dashed gainsboro;
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>